<template>
  <v-container grid-list-xl salesorderquotesettings style="overflow: hidden !important;">
    <v-form>
      <v-layout row wrap>
        <v-flex lg12 v-if="showMeta == true">
          <h2 >Delivery signed and accepted by:</h2>
        </v-flex>
        <v-flex lg1 v-if="showMeta == true">
          <label class="blackLabel">Name:</label>
        </v-flex>
        <v-flex lg2 v-if="showMeta == true">
          <v-text-field label="Name" v-model="metaData.name" solo></v-text-field>
        </v-flex>
        <v-flex lg9 v-if="showMeta == true">
        </v-flex>
        <v-flex lg1 v-if="showMeta == true">
          <label class="blackLabel">Surname:</label>
        </v-flex>
        <v-flex lg2 v-if="showMeta == true">
          <v-text-field label="Surname" v-model="metaData.surname" solo></v-text-field>
        </v-flex>
        <v-flex lg9 v-if="showMeta == true">
        </v-flex>
        <v-flex lg1 v-if="showMeta == true">
          <label class="blackLabel">ID No:</label>
        </v-flex>
        <v-flex lg2 v-if="showMeta == true">
          <v-text-field label="ID No" v-model="metaData.idNo" solo></v-text-field>
        </v-flex>
        <v-flex lg9 v-if="showMeta == true">
        </v-flex>
        <v-flex lg1 v-if="showMeta == true">
          <label class="blackLabel">Location:</label>
        </v-flex>
        <v-flex lg2 v-if="showMeta == true">
          <v-text-field label="Location" v-model="metaData.location" solo></v-text-field>
        </v-flex>
        <v-flex lg9 v-if="showMeta == true">
        </v-flex>
        <v-flex lg1 v-if="showMeta == true">
          <label class="blackLabel">Employer:</label>
        </v-flex>
        <v-flex lg2 v-if="showMeta == true">
          <v-text-field label="Employer" v-model="metaData.employer" solo></v-text-field>
        </v-flex>
        <v-flex lg9 v-if="showMeta == true">
        </v-flex>
        <v-flex lg9 v-if="showMeta == true">
          <v-btn color="info" style="float: left;" @click="fncSaveMeta">Update</v-btn>
          <v-btn class="text-xs-right cancelButton" style="float: left;" @click.stop="fncCancelMeta">Update Later</v-btn>
        </v-flex>
        <v-tabs slider-color="grey" v-if="globalModalParams && globalModalParams.quoteAttachments && globalModalParams.quoteAttachments.length > 0 && showMeta == false">
          <v-tab class="tab" :key="1" ripple>Purchase Order Attachments</v-tab>
          <v-tab class="tab" :key="2" ripple>Quote Attachments</v-tab>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">

            <input type="file" id="quoteFile" class="fileUpload" @change="fncSetImageObj">
            <div class="fileHolder">
              <p>Drag & Drop / <u>Click to Add Files</u></p>
              <p class="filerules">Maximum file size allowed:<b> {{ objAuthorize.max_upload_size }}MB</b><br>
                File types supported:<b> {{ objAuthorize.allowed_file_types }}</b></p>
              <small>{{ fileName }}</small>
            </div>
            <small class="pt-4 pb-4" v-if="objSoSettings.length == 0">No attachments have been uploaded to this purchase order</small>
            <br />

            <v-data-table :headers="headers"  :items="objSoSettings" v-if="objSoSettings.length != 0" class="elevation-1 " hide-actions>
              <template slot="items" slot-scope="props">
                <tr>
                  <td width="25%">
                    <a  @click.prevent="fncOpenFile(props.item.path)">{{ props.item.original_filename }}</a>
                    <div style="margin-top: 10px; text-indent: 5px;" v-if="fncCanUpdatePod(props.item) && props.item.meta_data != null">
                      <b>Delivery signed and Received by:</b>
                      <div><b>Name:</b> {{ JSON.parse(props.item.meta_data).name }} {{ JSON.parse(props.item.meta_data).surname }}</div>
                      <div><b>ID No:</b> {{ JSON.parse(props.item.meta_data).idNo }}</div>
                      <div><b>Location:</b> {{ JSON.parse(props.item.meta_data).location }}</div>
                      <div><b>Employer:</b> {{ JSON.parse(props.item.meta_data).employer }}</div>
                    </div>
                  </td>
                  <td width="15%">{{ fncFormatDate(props.item.created_timestamp) }}</td>
                  <td width="20%" v-if="attachmentCategories.length > 1" class="text-xs-right"><v-select :items="attachmentCategories" label="Attachment Category" @input="fncSaveAttachmentCategory(props.item.id, props.item )" class="dropdown" v-model="props.item.category" item-value="id" item-text="name" solo single-line></v-select></td>
                  <td width="30%" class="text-xs-right">
                      <div style="margin-top: 10px;font-size: 12px !important; display: flex; justify-content: space-between;">
                        <v-btn color="info" v-if="fncCanUpdatePod(props.item)"  :style="getStyle()" @click="fncShowMeta(props.item.id, props.item.meta_data)">UPDATE ORDER RECIPIENT DETAILS</v-btn>
                        <v-btn color="info" v-if="fncCanUpdatePod(props.item) && globalModalParams && globalModalParams.fullQuote && globalModalParams.fullQuote.status  !== 'POD Uploaded'" style="width: 48%;" @click="fncUpdatePodStatus" v-html="fncCheckPodStatus()"></v-btn>
                      </div>
                  </td>
                  <td width="5%" class="text-xs-left"><a @click.prevent="fncRemoveFile(props.item)"><i class="material-icons">delete</i></a></td>
                  <td width="5%">
                    <v-checkbox @change="fncMarkPaid(props.item)" style="display: inline-block;" v-model="props.item.is_paid"></v-checkbox>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
            <p>These are attachments that were loaded to the Quote.</p><br>
            <v-data-table :headers="qHeaders" :items="globalModalParams.quoteAttachments" class="elevation-1" hide-actions>
              <template slot="items" slot-scope="props">
                <td width="50%"><a @click.prevent="fncOpenFile(props.item.path)">{{ props.item.original_filename }}</a></td>
                <td width="50%"><a @click.prevent="fncOpenFile(props.item.path)">{{ props.item.created_timestamp }}</a></td>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs>
        <v-flex lg12 style="position: relative" v-if="globalModalParams && globalModalParams.quoteAttachments && globalModalParams.quoteAttachments.length <= 0 && showMeta == false">
          <p class="smalltext"><b>Maximum file size allowed:</b> {{ objAuthorize.max_upload_size }}MB</p>
          <p class="smalltext"><b>File types supported:</b> {{ objAuthorize.allowed_file_types }}</p><br><br>
          <input type="file" id="quoteFile" class="fileUpload" @change="fncSetImageObj">
          <div class="fileHolder">
            <p>Drag & Drop / Click to Add Files</p>
            <small>{{ fileName }}</small>
          </div>
            <small class="pt-4 pb-4" v-if="objSoSettings.length == 0">No attachments has been uploaded to this sales order</small>
          <br />
            <v-data-table :headers="headers" :items="objSoSettings" v-if="objSoSettings.length != 0" class="elevation-1 overflow-x-auto" hide-actions >
              <template slot="items" slot-scope="props">
                <tr>
                  <td width="25%" class="text-xs-left" >
                  <a  @click.prevent="fncOpenFile(props.item.path)">{{ props.item.original_filename }}</a>

                  <div style="margin-top: 10px; text-indent: 5px;" v-if="fncCanUpdatePod(props.item) && props.item.meta_data != null">

                    <b>Delivery signed and Received by:</b>
                    <div><b>Name:</b> {{ JSON.parse(props.item.meta_data).name }} {{ JSON.parse(props.item.meta_data).surname }}</div>
                    <div><b>ID No:</b> {{ JSON.parse(props.item.meta_data).idNo }}</div>
                    <div><b>Location:</b> {{ JSON.parse(props.item.meta_data).location }}</div>
                    <div><b>Employer:</b> {{ JSON.parse(props.item.meta_data).employer }}</div>
                  </div>

                </td>
                <td width="15%" class="text-xs-left">{{ fncFormatDate(props.item.created_timestamp) }}</td>
                <td width="20%" v-if="attachmentCategories.length > 1" class="text-xs-right"><v-select :items="attachmentCategories" label="Attachment Category" @input="fncSaveAttachmentCategory( props.item.id, props.item )" class="dropdown" v-model="props.item.category" item-value="id" item-text="name" solo single-line></v-select></td>
                <td width="30%" class="text-xs-right">
                  <div style="margin-top: 10px;font-size: 12px !important; display: flex; justify-content: space-between;">
                    <v-btn color="info" v-if="fncCanUpdatePod(props.item)" :style="getStyle()" @click="fncShowMeta(props.item.id, props.item.meta_data)">UPDATE ORDER RECIPIENT DETAILS</v-btn>
                    <v-btn color="info" v-if="fncCanUpdatePod(props.item) && globalModalParams && globalModalParams.fullQuote.status  !== 'POD Uploaded'" style="width: 48%;" @click="fncUpdatePodStatus" v-html="fncCheckPodStatus()"></v-btn>
                  </div>

                </td>
                <td width="5%" class="text-xs-right">
                  <a @click.prevent="fncRemoveFile(props.item)"><i class="material-icons">delete</i></a>
                </td>
                  <td width="5%">
                    <v-checkbox @change="fncMarkPaid(props.item)" style="display: inline-block;" v-model="props.item.is_paid"></v-checkbox>
                  </td>
                </tr>

              </template>
            </v-data-table>
          </v-flex>
          <div class="pl-4 pr-4 pb-4 buttonHolder">
            <div style="float: right">
              <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Save and Close</v-btn>
            </div>
          </div>
</v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'Settings',
    data() {
      return {
        soId: null,
        fileName: '',
        metaData: {
          name: '',
          surname: '',
          idNo: '',
          location: '',
          employer: '',
        },
        podCategory: this.$store.getters.podCategory,
        headers: [
          { text: 'File Name', value: 'name', width: '25%' },
          { text: 'Date Uploaded', value: 'name', width: '15%' },
          { text: 'Category', value: 'name', width: '20%' },
          { text: '', value: 'button', width: '30%' },
          { text: 'Delete', value: 'delete', width: '5%' },
          { text: 'Is Paid', value: 'is_paid', width: '5%' }
        ],
        allowedFileTypes: [],
        maxFileSize: 5,
        qHeaders: [
          { text: 'File Name', value: 'name', width: '50%' },
          { text: 'Date Uploaded', value: 'name', width: '50%' }
        ],
        showMeta: false
      };
    },
    methods: {
      fncCheckPodStatus() {
        for( var s in this.soStatusList ) {
          if( this.soStatusList[s].is_pod_uploaded == 'Yes' ) {
            return 'Advance To ' + '"'+this.soStatusList[s].description+'"';
          }
        }
        return 'No Status Set';
      },
      getStyle(){
        if (this.globalModalParams && this.globalModalParams.fullQuote && this.globalModalParams.fullQuote.status !== 'POD Uploaded'){
          return 'width: 48%;'
        }
        else{
          return 'width: 78%;'
        }
      },
      fncShowMeta(id, meta) {
        this.showMeta = true;
        this.$store.commit('setGlobalModalTitle', 'Delivery Note' + ' - ' + this.globalModalParams.fullQuote.quoteNo);
        this.soId = id
        if (meta != null)
        {
          // console.log(typeof meta)
          meta = JSON.parse(meta)
          this.metaData = { name: meta.name,  surname: meta.surname,  idNo: meta.idNo,  location: meta.loading,  employer: meta.employer }
        }
        else{
          this.metaData = { name: '',  surname: '',  idNo: '',  location: '',  employer: '' }
        }
      },
      fncSaveMeta() {
        var vendorId = 0;
        if( this.globalModalParams.fullQuote.vendor != undefined && this.globalModalParams.fullQuote.vendor != 'undefined' ) {
          vendorId = this.globalModalParams.fullQuote.vendor;
        } else if( this.globalModalParams.fullQuote.vendorId != undefined && this.globalModalParams.fullQuote.vendorId != 'undefined' ) {
          vendorId = this.globalModalParams.fullQuote.vendorId;
        }
        this.$store.dispatch({
          type: 'fncUpdateSoMeta',
          metaData: this.metaData,
          vendor: vendorId,
          quote: this.globalModalParams.fullQuote.quoteId,
          soId: this.soId
        })
        var oldThis = this;
        setTimeout(function(){
          oldThis.showMeta = false;
          oldThis.$store.dispatch('fncSoSettings', oldThis.globalModalParams.fullQuote);
        }, 500);
        this.$store.commit('setGlobalModalTitle', 'Purchase Order Attachments' + ' - ' + this.globalModalParams.fullQuote.quoteNo);
        this.$forceUpdate()
      },
      fncCancelMeta() {
        this.showMeta = false;
        this.$store.commit('setGlobalModalTitle', 'Purchase Order Attachments' + ' - ' + this.globalModalParams.fullQuote.quoteNo);
      },
      fncCanUpdatePod( item ) {
        var hasStatus = false;
        for( var s in this.soStatusList ) {
          if( this.soStatusList[s].is_pod_uploaded == 'Yes' || this.soStatusList[s].is_pod_uploaded == '1' ) {
            hasStatus = true;
          }
        }

        if( hasStatus == true ) {
          if( item.category != this.podCategory ) {
            var hasStatus = false;
          }
        }
        // else if ( item.category == this.podCategory ){
        //   hasStatus = true
        // }

        return hasStatus;
      },
      fncUpdatePodStatus() {

        var newStatus = [];
        for( var s in this.soStatusList ) {
          if( this.soStatusList[s].is_pod_uploaded == 'Yes' || this.soStatusList[s].is_pod_uploaded == '1' ) {
            newStatus = this.soStatusList[s];
          }
        }

        var podUpdate = {
          type: 'quote_status_change',
          prev_value: this.globalModalParams.fullQuote.status,
          new_value: newStatus.description,
          user: this.objAuthorize.id,
          target: this.globalModalParams.quote,
          data: 'Vendor: Updated from file upload screen',
          save: true
        }

        this.$store.dispatch('fncUpdatePodStatus', podUpdate);
        let oldThis = this;
        setTimeout(function(){
          oldThis.showMeta = false;
          oldThis.$store.dispatch('fncSoSettings', oldThis.globalModalParams.fullQuote);
        }, 500);
        this.$forceUpdate()
      },
      fncGetLocalizedDateFromUTC ( theDate ) {

        var options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "numeric",
          minute: "numeric",
          hour12: false
        };

        var newDate = new Date( Date.parse(theDate + ' UTC') );
        var dateString = newDate.toLocaleString("en", options);
        var objDate = dateString.split(',');

        var newDate = objDate[0].split('/');

        var strDate = newDate[2] + '-' + newDate[0] + '-' + newDate[1] + ' ' + objDate[1];

        return strDate;

      },
      fncFormatDate( date ) {
        var splitDate = date.split(' ');
        var singleSplit = splitDate[0].split('-');
        var newDate = singleSplit[1]+'-'+singleSplit[0]+'-'+singleSplit[2];
        // return newDate + ' ' + splitDate[1];
        return newDate;
      },
      fncOpenFile(fileUrl) {
        window.open(fileUrl, '_blank');
      },
      fncHideModal() {
        //this.$store.commit('hideModal');
        window.location.reload();
      },
      fncChangeUserType() {
        var companyType = this.userType == 2 ? 1 : 2;
        this.$store.dispatch({
          type: 'fncResetSetupUserCreate',
          companyType: companyType,
          userType: this.userType
        });
      },
      fncUpdateQuoteSettings() {
        this.$store.dispatch('fncUpdateQuoteSettings')
      },
      fncMarkPaid(item){
        const isChecked = (item.is_paid) ? 1 : 0;
        const id = item.id;
        this.$store.dispatch({
          type: 'fncMarkPaid',
          attachmentId: id,
          is_paid: isChecked,
          quoteId: this.globalModalParams.quoteId
        })
      },
      fncRemoveFile(key) {
        var doDelete = confirm('Are you sure you want to delete this file');
        if (doDelete == true) {
          this.$store.dispatch({
            type: 'fncRemoveSoAttachment',
            details: key,
            quoteNo: this.globalModalParams.quoteNo
          })
        }
      },
      fncSetImageObj(e) {
        var files = e.target.files[0] || e.dataTransfer.files[0];
        var vm = this;
        var fivemeg = 5 * 1000000;
        if (parseInt(files.size) > fivemeg) {
          var snackDetails = { color: 'error', message: 'Please upload a file smaller than 5MB', display: true };
          this.$store.commit('setSnack', snackDetails);
        } else {
          var fileObj = String(files.name).split('.');
          var fileType = '.'+fileObj[fileObj.length-1];
          fileType = fileType.toLowerCase();
          if ( this.allowedFileTypes.indexOf( fileType ) != -1 ) {
          //if (files.type == 'application/pdf' || files.type === 'image/png' || files.type === 'image/jpg' || files.type === 'image/jpeg' || files.type == 'application/pdf' || files.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || files.type == 'application/vnd.ms-excel' || files.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || files.type == 'application/msword' || files.type == 'application/x-zip-compressed' || files.type == 'text/plain') {
            this.fileObj = files;
            var currentInput = document.getElementById('quoteFile');
            currentInput.value = '';
            this.$store.dispatch({
              type: 'fncUploadSoImage',
              files: files,
              quoteId: this.globalModalParams.quote,
              quoteNo: this.globalModalParams.quoteNo,
              vendorId: this.globalModalParams.vendor,
              vendor: this.globalModalParams.vendor,
              fullQuote: this.globalModalParams.fullQuote,
              soId: this.globalModalParams.fullQuote.soId,
              objSoSettings: this.objSoSettings,
              category: this.podCategory
            })
          } else {
            var snackDetails = { color: 'error', message: 'Please upload a valid file type', display: true };
            this.$store.commit('setSnack', snackDetails);
          }
        }
      },
      fncSaveAttachmentCategory(id, attachment ) {
        if( this.podCategory == attachment.category ) {
          this.showMeta = true;
          this.soId = id
          this.metaData = { name: '',  surname: '',  idNo: '',  location: '',  employer: '' };
          this.$store.commit('setGlobalModalTitle', 'Delivery Note' + ' - ' + this.globalModalParams.fullQuote.quoteNo);
        } else {
          this.showMeta = false;
          this.$store.commit('setGlobalModalTitle', 'Purchase Order Attachments' + ' - ' + this.globalModalParams.fullQuote.quoteNo);
        }
        this.$store.dispatch({
          type: 'fncUpdateAttachmentCategory',
          attachmentId: attachment,
          quoteId: attachment.quote
        });

      }
    },
    components: {
      DatePicker
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'objSoSettings',
        'quoteAttachments',
        'soStatusList',
        'attachmentCategories',
        'globalModalTitle',
      ])
    },
    created() {
      this.allowedFileTypes = String(this.objAuthorize.allowed_file_types).split(',');
     // this.$store.dispatch('fncSoSettings', this.globalModalParams.quoteId);
    },
    beforeMount() {
      this.$store.commit('fncEmptyAttachmentCategories');
      this.$store.dispatch('fncGetAttachmentCategories');
      this.metaData = JSON.parse( this.globalModalParams.metaData );

      if( this.metaData == null || this.metaData == 'null' ) {
        this.metaData = { name: '',  surname: '',  idNo: '',  location: '',  employer: '' };
      }

    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
  tr{
    vertical-align: initial;
  }

  td div {
    font-size: 12px !important;
}
  .icon--selection-control {
    visibility: visible !important;
  }
</style>
